import React from "react"

import { Checkbox } from "@coval/ui"

import type { RoleFilterConfig, TranscriptRole } from "@/types/metrics/metadata"

import { TRANSCRIPT_ROLES } from "../types"

interface RoleFilterEditorProps {
  filter: RoleFilterConfig
  onChange: (filter: RoleFilterConfig) => void
}

export const RoleFilterEditor: React.FC<RoleFilterEditorProps> = ({
  filter,
  onChange,
}) => {
  const handleToggle = (role: TranscriptRole, checked: boolean) => {
    const next = checked
      ? Array.from(new Set([...filter.roles, role]))
      : filter.roles.filter((r) => r !== role)
    // Schema requires at least one role — ignore a toggle that would empty the list.
    if (next.length === 0) {
      return
    }
    onChange({ ...filter, roles: next })
  }

  return (
    <fieldset className="flex items-center gap-x-4 border-0 p-0 m-0">
      <legend className="sr-only">Role selection</legend>
      {TRANSCRIPT_ROLES.map((role) => {
        const checked = filter.roles.includes(role.value)
        return (
          <label
            key={role.value}
            className="flex items-center gap-2 text-sm cursor-pointer"
          >
            <Checkbox
              checked={checked}
              onCheckedChange={(v) => handleToggle(role.value, v === true)}
              aria-label={`Include ${role.label} in role filter`}
            />
            <span>{role.label}</span>
          </label>
        )
      })}
    </fieldset>
  )
}
